module.exports = __webpack_public_path__ + "img/logo.7c4f203d.svg";